export const seriesStats = [
  {
    id: "stat-1",
    value: "16",
    label: "课程条目",
    note: "从第 01 课到完整版合辑",
  },
  {
    id: "stat-2",
    value: "5",
    label: "学习阶段",
    note: "导览 / 基础 / 进阶 / 实战 / 完整版",
  },
  {
    id: "stat-3",
    value: "约 6 小时",
    label: "完整版时长",
    note: "合辑一次看完",
  },
  {
    id: "stat-4",
    value: "3 种",
    label: "资源形式",
    note: "视频 / 图文 / 测评清单",
  },
];

export const catalogStages = [
  {
    id: "stage-1",
    name: "入门导览",
    range: "第 01 – 02 课",
    count: "2 课",
    duration: "约 28 分钟",
    purpose: "建立全局认识，先把系列结构和术语弄清楚，再正式开始学习。",
    keywords: ["整体结构", "术语速查", "新手必看"],
  },
  {
    id: "stage-2",
    name: "核心基础",
    range: "第 03 – 05 课 · 12 – 13 课",
    count: "5 课",
    duration: "约 1 小时 42 分钟",
    purpose: "打牢基础，掌握核心方法、概念与常见误区，并通过自测确认掌握程度。",
    keywords: ["学习框架", "核心概念", "误区纠正"],
  },
  {
    id: "stage-3",
    name: "进阶技巧",
    range: "第 06 – 08 课 · 14 课",
    count: "4 课",
    duration: "约 1 小时 42 分钟",
    purpose: "把知识点串联成体系，学会分解复杂问题，并用工具优化流程。",
    keywords: ["知识体系", "案例分解", "效率工具"],
  },
  {
    id: "stage-4",
    name: "实战案例",
    range: "第 09 – 11 课",
    count: "3 课",
    duration: "约 1 小时 37 分钟",
    purpose: "在完整案例中走一遍全流程，多场景演练并做好复盘记录。",
    keywords: ["全流程", "多场景", "复盘优化"],
  },
  {
    id: "stage-5",
    name: "完整版",
    range: "第 15 – 16 课",
    count: "2 条",
    duration: "约 6 小时合辑",
    purpose: "全系列串联复习，或以合辑形式一次看完整套内容。",
    keywords: ["总复习", "合辑", "全收录"],
  },
];

export const learningPath = [
  {
    id: "path-1",
    phase: "第一步",
    title: "先看清整体，再决定怎么学",
    range: "建议用时：1 天",
    description:
      "先看完导览部分，弄明白整个系列分成哪几个阶段、每阶段解决什么问题，再决定自己的学习节奏。",
    focus: ["系列结构", "学习顺序", "时间安排"],
  },
  {
    id: "path-2",
    phase: "第二步",
    title: "打牢基础，别急着跳到进阶",
    range: "建议用时：1 – 2 周",
    description:
      "按顺序学习核心基础部分，每学完一课就对照自测清单确认掌握程度，未达标先补课再往前走。",
    focus: ["核心方法", "概念理解", "自测确认"],
  },
  {
    id: "path-3",
    phase: "第三步",
    title: "把点连成线，形成体系",
    range: "建议用时：2 – 3 周",
    description:
      "进入进阶技巧部分，重点是建立知识之间的联系，学会把零散内容整理成可复用的体系。",
    focus: ["知识体系", "笔记整理", "流程优化"],
  },
  {
    id: "path-4",
    phase: "第四步",
    title: "用实战检验方法",
    range: "建议用时：2 – 4 周",
    description:
      "跟随实战案例走完整流程，在不同场景中演练同一套方法，并坚持做完复盘记录。",
    focus: ["全流程", "多场景", "复盘"],
  },
  {
    id: "path-5",
    phase: "第五步",
    title: "看完整版，查漏补缺",
    range: "建议用时：随时",
    description:
      "最后用完整版做一次总复习，把前面遗漏的点补齐，形成对整个系列的完整印象。",
    focus: ["总复习", "查漏补缺", "完整印象"],
  },
];

export const videoResources = [
  {
    id: "res-1",
    title: "系列导览合集｜第 01 – 02 课连播",
    category: "入门导览",
    duration: "28 分钟",
    quality: "高清",
    format: "视频",
    note: "适合第一次接触系列的用户，连播无需逐集切换。",
  },
  {
    id: "res-2",
    title: "核心基础合集｜第 03 – 05 课连播",
    category: "核心基础",
    duration: "1 小时 06 分钟",
    quality: "高清",
    format: "视频",
    note: "基础方法集中讲解，建议配合笔记一起看。",
  },
  {
    id: "res-3",
    title: "进阶技巧合集｜第 06 – 08 课连播",
    category: "进阶技巧",
    duration: "1 小时 24 分钟",
    quality: "高清",
    format: "视频",
    note: "知识点串联与案例分解，节奏偏快，可分段观看。",
  },
  {
    id: "res-4",
    title: "实战案例合集｜第 09 – 11 课连播",
    category: "实战案例",
    duration: "1 小时 37 分钟",
    quality: "高清",
    format: "视频",
    note: "三段完整实战，建议对照自己的场景边看边记。",
  },
  {
    id: "res-5",
    title: "阶段测评清单｜基础篇 + 进阶篇",
    category: "核心基础",
    duration: "33 分钟",
    quality: "图文",
    format: "图文",
    note: "两份自测清单，可打印后逐项对照使用。",
  },
  {
    id: "res-6",
    title: "完整版合辑｜第一课到最后一课",
    category: "完整版",
    duration: "约 6 小时",
    quality: "高清",
    format: "视频",
    note: "全系列整合，带章节标记，适合系统过一遍。",
  },
];

export const highlights = [
  {
    id: "hl-1",
    icon: "ri-list-check-2",
    title: "目录清晰",
    description:
      "所有集数按阶段归纳，第几课讲什么、时长多少一目了然，不用一集集翻找。",
  },
  {
    id: "hl-2",
    icon: "ri-vidicon-line",
    title: "资源集中",
    description:
      "视频、图文与测评清单集中整理，同一主题的多种形式放在一起方便对照。",
  },
  {
    id: "hl-3",
    icon: "ri-route-line",
    title: "路径明确",
    description:
      "给出从导览到完整版的推荐学习顺序，告诉你先看什么、后看什么更高效。",
  },
  {
    id: "hl-4",
    icon: "ri-filter-3-line",
    title: "快速定位",
    description:
      "支持按阶段筛选与关键词搜索，输入关键词即可在本页范围内找到相关课程。",
  },
  {
    id: "hl-5",
    icon: "ri-time-line",
    title: "进度可控",
    description:
      "每课标注时长与难度，方便结合自己的时间安排，合理分配每次学习量。",
  },
  {
    id: "hl-6",
    icon: "ri-bookmark-3-line",
    title: "便于回顾",
    description:
      "结构化的目录与自测清单，方便学完之后回头复习与查漏补缺。",
  },
];

export const faqs = [
  {
    id: "faq-1",
    question: "「秘密教学」系列一共包含多少课？",
    answer:
      "按本页整理的目录，系列共归纳为 16 个条目，覆盖入门导览、核心基础、进阶技巧、实战案例到完整版合辑。其中部分条目为图文或测评清单形式，具体数量以实际资源为准。",
  },
  {
    id: "faq-2",
    question: "应该从哪一课开始看？",
    answer:
      "建议从第 01 课的系列导览开始，先建立整体印象；再看第 02 课补齐术语背景。基础扎实之后，再按核心基础、进阶技巧、实战案例的顺序推进，不要跳着看。",
  },
  {
    id: "faq-3",
    question: "完整版和逐课观看有什么区别？",
    answer:
      "逐课观看适合边学边练、按自己的节奏推进；完整版合辑则把第一课到最后一课按顺序整合，带章节标记，适合系统过一遍或在学完之后做总复习。",
  },
  {
    id: "faq-4",
    question: "课程里的「阶段测评」是什么？",
    answer:
      "阶段测评是两份自测清单，分别对应核心基础篇与进阶篇。完成一个阶段后逐项对照，确认是否真正掌握，未达标的项目可以据此回看对应课程。",
  },
  {
    id: "faq-5",
    question: "页面上的筛选和搜索是做什么的？",
    answer:
      "它们只作用于本页已经整理好的课程目录，帮助你按阶段筛选课程，或用关键词快速找到相关集数，不会跳转到外部页面，也不会上传任何数据。",
  },
  {
    id: "faq-6",
    question: "手机上能正常浏览吗？",
    answer:
      "可以。页面采用响应式布局，课程列表、目录总览与常见问题在手机上都能完整阅读，折叠内容在进入页面时就已经存在，展开即可查看。",
  },
  {
    id: "faq-7",
    question: "这里的课程信息是实时更新的吗？",
    answer:
      "本页内容为对系列结构的整理与归纳，供快速定位参考。若实际资源有增删或调整，以官方发布的实际内容为准。",
  },
];